import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { SearchService } from 'src/app/services/search-service';
import { NamePopularity } from '../name-popularity-data/name-popularity-data.component';
import { platePath } from 'src/app/utils/canonical-url';

@Component({
  selector: 'pla-initials-popularity-table',
  templateUrl: './initials-popularity-table.component.html',
  styleUrls: ['./initials-popularity-table.component.scss']
})
export class InitialsPopularityTableComponent implements OnInit {

  @Input() public results: NamePopularity[];

  public paginationPageSize: number = 10;
  private currentPageIndex = 0;
  public paginationChange: EventEmitter<any>;
  public viewResults: NamePopularity[] = [];
  public displayResults: NamePopularity[] = [];

  public sorts: { name: string, sort: 'asc' | 'desc' | 'none' }[] = [
    { name: 'registration', sort: 'none' },
    { name: 'popularity', sort: 'asc' },
    { name: 'resalePrice', sort: 'none' }
  ]

  constructor(private router: Router, private searchService: SearchService) { }

  ngOnInit(): void {
    this.viewResults = this.results;
    setTimeout(() => {
      this.sortData('popularity', 1);
      this.gotoPage(this.currentPageIndex);
    }, 100);
  }

  public GotoPlate(registration: string): void {
    this.router.navigate([platePath(registration)])
  }

  public sortChange(sort: string) {
    var index = this.sorts.findIndex(s => s.name == sort);
    if (index == -1) return;
    this.sorts[index].sort = this.sorts[index].sort == 'asc' ? 'desc' : 'asc';
    this.sorts = this.sorts.map(s => { if (s.name == sort) return s; s.sort = 'none'; return s; });
    // sort
    this.sortData(sort, index);
    this.gotoPage(0);
  }

  private sortData(sort: string, index: number): void {
    console.log(sort, this.sorts[index].sort)
    if (sort === 'registration') {
      if (this.sorts[index].sort === 'asc') {
        this.viewResults = this.viewResults.sort((a, b) => a.name.localeCompare(b.name));
      } else {
        this.viewResults = this.viewResults.sort((a, b) => b.name.localeCompare(a.name));
      }
    } else {
      if (this.sorts[index].sort === 'asc') {
        this.viewResults = this.viewResults.sort((a, b) => a[sort] - b[sort])
      } else {
        this.viewResults = this.viewResults.sort((a, b) => b[sort] - a[sort])
      }
    }
  }

  public isSorting(sort: string): 'none' | 'asc' | 'desc' {
    var index = this.sorts.findIndex(s => s.name == sort);
    if (index == -1) return 'none';
    return this.sorts[index].sort;
  }

  public sortingIcon(sort: string): string {
    const sortType = this.isSorting(sort);
    if (sortType === 'none') return 'unfold_more';
    if (sortType === 'asc') return 'north';
    if (sortType === 'desc') return 'south';
  }

  public paginate(page: PageEvent): void {
    this.gotoPage(page.pageIndex);
    if (this.paginationChange != null) this.paginationChange.emit(page);
  }

  private gotoPage(pageIndex: number) {
    this.currentPageIndex = pageIndex;
    this.displayResults = this.get_page_range(
      pageIndex,
      this.paginationPageSize
    );
  }

  public get_page_range(page_index, page_size): NamePopularity[] {
    var min_data_range = page_index * page_size;
    var max_data_range = (page_index + 1) * page_size;
    if (this.viewResults == undefined) return [];
    max_data_range =
      this.viewResults.length > max_data_range
        ? max_data_range
        : this.viewResults.length;
    const visibleResults = this.viewResults.slice(
      min_data_range,
      max_data_range
    );

    return visibleResults;
  }

}
